import { ColumnsType } from "antd/es/table";
import { IExportData } from "@/pages/export-list/types";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { getDomain } from "project-config/utils/domain";

const t = getTranslateNsT("center");

export const columns: ColumnsType<IExportData> = [
  {
    title: t("consumption_time_selector"),
    dataIndex: "consumeDate",
  },
  {
    title: t("user_operate_record_user_name"),
    dataIndex: "userName",
  },
  {
    title: t("bill_account_type"),
    dataIndex: "accountType",
    render: (row) => t(`consumption_account_type_${row}`),
  },
  {
    title: t("user_binfo_perfect_item_company_name"),
    dataIndex: "company",
  },
  {
    title: t("consumption_label_fee_type"),
    dataIndex: "feeType",
    render: (v) => t(`consumption_fee_type_${v}`),
  },
  {
    title: t("consumption_label_node_type"),
    dataIndex: "nodeType",
    render: (v) => ["CPU", "GPU", "CPU&GPU"][v] || "",
  },
  {
    title: t("consumption_currency"),
    dataIndex: "currency",
    render: (v) => (v === 1 ? "RMB" : "USD"),
  },
  {
    title: t("consumption_pay_amount"),
    dataIndex: "payAmount",
  },
  {
    title: t("consumption_cash_amount"),
    dataIndex: "cashAmount",
  },
  {
    title: t("consumption_balance_consume"),
    dataIndex: "feeAmount",
  },
  {
    title: t("consumption_coupon_consume"),
    dataIndex: "couponFeeAmount",
  },
  !getDomain()
    ? {
        title: t("consumption_youth_coupon_consume"),
        dataIndex: "couponQYFeeAmount",
      }
    : {},
  !getDomain()
    ? {
        title: t("consumption_voucher_fee_amount"),
        dataIndex: "voucherFeeAmount",
      }
    : {},
];
